// Get URL parameters
const queryString = window.location.search
const urlParams = new URLSearchParams(queryString)
const map_id = urlParams.get('map')
const defaultTitle = 'LifeSource Service Area'

// LifeSource maps API endpoints
const baseUrl = window.location.protocol + "//" + window.location.host + '/wp-json/midwest-donor-designation/v1/'
const countyOverallDataUrl = baseUrl + 'counties/' + map_id
const countySingleDataUrl = baseUrl + 'county'
const regionDataUrl = baseUrl + 'region/' + map_id
const fipsDataUrl = baseUrl + 'fips'

// HTML elements that will be updated at some point
const infoPanelTitle   = document.getElementById( 'infoPanelTitle' )
const ageGroupBars     = document.getElementById( 'ageGroups' )
const regCountText     = document.getElementById( 'infoPanelRegistrationCount' )
const desRateText      = document.getElementById( 'infoPanelDesignationRate' )
const statBoxGrid      = document.getElementById( 'statBoxGrid' )
const dateSlots        = document.querySelectorAll( '.js-report-date' )
const reportTitleSlots = document.querySelectorAll( '.js-report-title' )

// Mapbox settings
mapboxgl.accessToken = 'pk.eyJ1IjoibGlmZXNvdXJjZW1uZGFrIiwiYSI6ImNsYTAzZmZpMDA0c20zcW5zbDNlYWlpb2gifQ.tSnYrDnnqRceu-qGMsKbRg'
const center = [ -97.3, 45.92 ]

// Misc vars to update later
let filterByState = null

let cache = {
  regionData: null,
  overallCountyData: null,
  countyFipsData: null,
  countyData: []
}

const map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/lifesourcemndak/cla03rmf6004915qfygzcjzly',
  center: center,
  maxBounds: [
    [ -110.474789, 39.740986 ], // SW
    [ -83.262664, 53.225768 ] // NE
  ],
  maxZoom: 7,
  zoom: 5.5
})

// -------------------------------------------------------------------------
// FILTERING AND TRANSITIONING
// -------------------------------------------------------------------------

function setupFilterButtons() {

  const filterButtons = document.getElementById( 'modeButtons' ).querySelectorAll( 'button' )

  filterButtons.forEach( button => {
    button.addEventListener( 'click', () => {

      // deactivate all buttons
      filterButtons.forEach( b => { b.classList.remove('is-active') } )

      // activate this button
      button.classList.add('is-active')

      const filter = button.getAttribute( 'data-mode' )
      filterByState = filter === 'region' ? null : filter

      updateLayerProperties()
      flyToArea()

      if ( !filterByState ) {
        
        updateInfoPanel( defaultTitle,
          cache.regionData.registrations,
          cache.regionData.designations,
          cache.regionData.ageGroups
        )

      } else if ( ['MN','ND','SD'].includes( filterByState ) ) {
        
        if ( cache.regionData.states ) {
          cache.regionData.states.forEach( record => {
            if ( record.state === filterByState ) {
              updateInfoPanel( convertAbbreviation( filterByState ),
                record.registrations,
                record.designations,
                record.ageGroups
              )
            }
          } )
        }
         
      }

    } )
  } )

}

function flyToArea() {

  const duration = 1000
  let flyProps

  switch ( filterByState ) {

    case null :
      flyProps = {
        center: center,
        duration: duration,
        zoom: 5.5
      }
      break;

    case 'MN' :
      flyProps = {
        center: [-93.991981, 46.179830],
        duration: duration,
        zoom: 5.8
      }
      break;

    case 'ND' :
      flyProps = {
        center: [-100.499775, 47.442950],
        duration: duration,
        zoom: 6.25
      }
      break;
      
    case 'SD' :
      flyProps = {
        center: [-100.090558, 44.410240],
        duration: duration,
        zoom: 6.25
      }
      break;

  }

  // Adjust for smaller screens
  if ( window.matchMedia( "(max-width: 599px)" ).matches ) {
    if ( filterByState ) {
      flyProps.zoom = 4.8
    } else {
      flyProps.zoom = 4
    }
  }

  map.flyTo( flyProps )

}

function updateLayerProperties() {

  // update properties to reflect filtered dataset
  map.setPaintProperty( 'counties', 'fill-outline-color', [
    'case',
    [ "in", [ "get", "FIPS" ], [ "literal", getRangeFips( getFilteredCounties(), 0, 1 ) ] ],
    '#000000',
    'transparent'
  ] )

  map.setPaintProperty( 'counties', 'fill-color', [
    'case',
    [ "in", [ "get", "FIPS" ], [ "literal", getRangeFips( getFilteredCounties(), 0.75, 1 ) ] ],    '#8FD000',
    [ "in", [ "get", "FIPS" ], [ "literal", getRangeFips( getFilteredCounties(), 0.65, 0.75 ) ] ], '#C5EF9D',
    [ "in", [ "get", "FIPS" ], [ "literal", getRangeFips( getFilteredCounties(), 0.55, 0.65 ) ] ], '#FFEF76',
    [ "in", [ "get", "FIPS" ], [ "literal", getRangeFips( getFilteredCounties(), 0.45, 0.55 ) ] ], '#FEB600',
    [ "in", [ "get", "FIPS" ], [ "literal", getRangeFips( getFilteredCounties(), 0, 0.45 ) ] ],    '#FF6B01',
    'transparent'
  ]);

  map.setFilter( 'county-hover-lines',
    [ "in", [ "get", "FIPS" ], [ "literal", getRangeFips( getFilteredCounties(), 0, 1 ) ] ]
  )

  map.setPaintProperty( 'county-select-lines', 'line-color',
    ['match', ['get', 'FIPS'], 0, 'black', 'transparent']
  );

}

function setZoomLevel() {

  if ( window.matchMedia( "(max-width: 1299px)" ).matches ) {
    map.setZoom(4.5)
  }

  if ( window.matchMedia( "(max-width: 599px)" ).matches ) {
    map.setZoom(3)
  }

}

// -------------------------------------------------------------------------
// DATA PARSING
// -------------------------------------------------------------------------

function getCountyData( fips ) {

  let foundInCache = false

  // Check to see if this county has already been retrieved
  cache.countyData.forEach( record => {
    if ( record.fips === fips ) {
      updateInfoPanel( record.county, record.registrations, record.designations, record.ageGroups )
      foundInCache = true
    }
  })

  // Otherwise get the record and cache it
  if ( !foundInCache ) {
    axios.get( countySingleDataUrl + '/' + map_id + '/?fips=' + fips )
    .then( response => {
      cache.countyData.push( response.data )
      const record = response.data
      updateInfoPanel( record.county, record.registrations, record.designations, record.ageGroups )
    } )
    .catch( error => {
      console.log( error )
    } )
  }

}

function convertAbbreviation( abbr ) {

  switch ( abbr ) {

    case 'MN':
      return 'Minnesota'
    case 'ND':
      return 'North Dakota'
    case 'SD':
      return 'South Dakota'
  }

}

function getFilteredCounties() {

  if ( filterByState === null ) {
    return cache.overallCountyData
  } else {
    return cache.overallCountyData.filter( county => county.state === filterByState )
  }

}

function getFilteredCountyIds() {

  return getFilteredCounties().map( county => county.fips )

}

function getRangeFips( data, min, max ) {
  return data
  .filter( county => { return ( county.designationPercentage >= min && county.designationPercentage < max ) } )
    .map( county => county.fips )
}

function getHightestCountForGroups( ageGroups, column ) {

  let highestValue = 0

  ageGroups.forEach( group => {

    if ( column === 'registrations' ) {
      if ( group.registrations > highestValue ) {
        highestValue = group.registrations
      }
    } else if ( column === 'designations' ) {
      if ( group.designations > highestValue ) {
        highestValue = group.designations
      }
    }

  } )

  return highestValue

}

// -------------------------------------------------------------------------
// INFO PANEL 
// -------------------------------------------------------------------------

function updateInfoPanel( title, registrations, designations, ageGroups ) {

  updateInfoPanelTitle( title )
  updateRegistrationsBox( registrations )
  updateDesignationRateBox( designations, registrations )
  buildAgeGroupChart( ageGroups )

  statBoxGrid.classList.remove('is-loading')

}

function updateInfoPanelTitle( text ) {

  text = ['LifeSource Service Area','Minnesota','North Dakota','South Dakota'].includes(text) ? text : text + ' County'

  infoPanelTitle.innerText = text

}

function updateRegistrationsBox( text ) {

  regCountText.innerText = numberWithCommas( text )

}

function updateDesignationRateBox( numerator, denominator ) {
  
  const value = Math.round( ( numerator / denominator ) * 100 )
  desRateText.innerText = value + '%';
  
}

function buildAgeGroupChart( ageGroups ) {

  const maxHeight = 150
  const highestRegVal = getHightestCountForGroups( ageGroups, 'registrations' )
  const regMultiplier = maxHeight / highestRegVal

  // remove existing age group bards
  while ( ageGroupBars.firstChild ) {
    ageGroupBars.removeChild( ageGroupBars.firstChild )
  }

  // if we have new age groups, add/build the bar graph
  if ( ageGroups ) {

    ageGroups.forEach( group => {

      const barWrap = document.createElement( 'div' )
      barWrap.classList.add( 'age-group-bar' )

      const regBar = document.createElement( 'div' )
      const bottomLabel = document.createElement( 'div' )
      const topLabel = document.createElement( 'div' )

      const desBar = document.createElement( 'div' )
      const desBarLabel = document.createElement( 'div' )

      topLabel.classList.add( 'age-group-bar__top-label' )
      topLabel.style.opacity = 0
      topLabel.innerHTML = numberWithCommas( group.registrations ) + ' <span class="screen-reader-text">Registrations</span>'

      regBar.classList.add( 'age-group-bar__registration-bar' )
      regBar.style.height = '0px'
      desBar.classList.add( 'age-group-bar__designation-bar' )
      desBar.style.height = '0px'
      desBarLabel.classList.add( 'age-group-bar__designation-bar-label' )
      desBarLabel.style.opacity = '0'

      bottomLabel.classList.add( 'age-group-bar__bottom-label' )
      bottomLabel.innerHTML = '<span class="screen-reader-text">Age</span> ' + group.age.replace( ' to ','-' )

      regBar.append( topLabel )
      barWrap.append( bottomLabel )
      barWrap.append( regBar )
      desBar.append( desBarLabel )
      barWrap.append( desBar )
      ageGroupBars.append( barWrap )

      const regBarHeight = ( group.registrations === highestRegVal ) ? maxHeight : ( regMultiplier * group.registrations )
      barWrap.style.height = regBarHeight + 'px'

      setTimeout( () => {
        regBar.style.height = '100%'
      }, 10 )

      let percentage = 0

      setTimeout( () => {
        percentage = Math.round( ( group.registrations / group.designations ) * 100 )
        desBarLabel.innerHTML = percentage + '%' + ' <span class="screen-reader-text">Donor designation rate</span>'
        desBar.style.height = percentage + '%'
        topLabel.style.opacity = 1

        if ( ( regBarHeight * ( percentage * 0.01 ) ) > 20 ) {
          desBarLabel.style.opacity = 1
        } else {
          regBar.closest('.age-group-bar').classList.add('has-hover')
        }

      }, 350 )

    } )
    
  }

}

function updateDateSlots() {

  dateSlots.forEach( slot => {
    slot.innerHTML = cache.regionData.report_date
  } )

}

function updateReportTitleSlots() {

  reportTitleSlots.forEach( slot => {
    slot.innerHTML = cache.regionData.report_title
  } )

}

// -------------------------------------------------------------------------
// UTILITIES
// -------------------------------------------------------------------------

function numberWithCommas( theNumber ) {

  return theNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

}

function toTitleCase( str ) {
  return str.replace(
    /\w\S*/g,
    function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
}

function filterCountyName( string ) {
  
  switch ( string ) {

    case 'Shannon County':
      string = 'Oglala Lakota County'
      break;

  }

  return string

}

// -------------------------------------------------------------------------
// MAP LOADING
// -------------------------------------------------------------------------

map.on( 'load', () => {
  
  let midwestFIPS = []
  let hoveredCountyID = null
  let selectedCounties = []

  const countyNameBox = new mapboxgl.Popup({
    closeButton: false,
    closeOnClick: false
  })

  // Get county outlines for map from existing Mapbox source
  map.addSource( 'counties', {
    'type': 'vector',
    'url': 'mapbox://mapbox.82pkq93d',
    'promoteId': { original: "FIPS" }
  })

  // Get regional data to display initially
  axios.get( regionDataUrl )
    .then( response => {
      const record = response.data
      cache.regionData = record
      updateDateSlots()
      updateReportTitleSlots()
      updateInfoPanel( defaultTitle, record.registrations, record.designations, record.ageGroups )
    })
    .catch( error => {
      console.error( 'Could not get region data' );
      console.log( 'url: ' + regionDataUrl )
      console.log( error )
    })

  // Get data from the LifeSource donor designation API
  axios.get( fipsDataUrl )
    // First we need a response for county FIPS data
    .then( response => {
      response.data.forEach( county => {
        midwestFIPS.push( county.fips )
      });
      return axios.get( countyOverallDataUrl )
    })
    // Then we need a response for overall county data
    .then( response => {
      cache.overallCountyData = response.data
      setupFilterButtons()
      let hoverCountyName = null

      // County shapes for color
      map.addLayer({
        'id': 'counties',
        'type': 'fill',
        'source': 'counties',
        'source-layer': 'original',
        'paint': {
          'fill-opacity': [
            'case',
            ['boolean', ['feature-state', 'hover'], false],
            1,
            0.7
          ]
        }
      })

      // Hover Outlines
      map.addLayer({
        'id': 'county-hover-lines',
        'type': 'line',
        'source': 'counties',
        'source-layer': 'original',
        'paint': {
          'line-color': [
            'case',
            ['boolean', ['feature-state', 'hover'], false],
            'rgba(0,0,0,0.3)',
            'transparent'
          ],
          "line-width": 1.5
        }
      })

      // Selected Outlines
      map.addLayer({
        'id': 'county-select-lines',
        'type': 'line',
        'source': 'counties',
        'source-layer': 'original',
        'paint': {
          'line-color': 'black',
          "line-width": 2.5
        }
      })

      updateLayerProperties()

      // ------------------------------------------
      map.on( 'mousemove', 'counties', ( e ) => {
    
        map.getCanvas().style.cursor = 'pointer'
        const mouseCoords = e.lngLat.wrap()
        const coordinates = new mapboxgl.LngLat(mouseCoords.lng, mouseCoords.lat);
        countyNameBox.setLngLat( coordinates )

        // Add infobox to map and continuously reposition it to follow cursor
        if ( hoveredCountyID !== null ) {
        
          map.setFeatureState(
            { source: 'counties', id: hoveredCountyID, sourceLayer: 'original' },
            { hover: true }
          )
          
          if ( getFilteredCountyIds().includes( e.features[0].id ) ) {
            countyNameBox.addTo(map)
            if ( hoverCountyName !== e.features[0].properties.COUNTY  ) {
              hoverCountyName = e.features[0].properties.COUNTY
              countyNameBox.setHTML( toTitleCase( filterCountyName( hoverCountyName ) ) )
            }
          } else {
            countyNameBox.remove()
          }

        }
                
        hoveredCountyID = e.features[0].id
  
        // Return other counties to their "un-hovered" state
        const otherFIPS = midwestFIPS.filter( item => item !== hoveredCountyID )
        otherFIPS.forEach( fip => {
          map.setFeatureState(
            { source: 'counties', id: fip, sourceLayer: 'original' },
            { hover: false }
          );  
        } )
    
      })

      // ------------------------------------------
      map.on( 'click', 'counties', ( e ) => {
        
        const fips = e.features[0].id

        if ( getFilteredCountyIds().includes( fips ) ) {
          selectedCounties[0] = e.features[0].id
          map.setPaintProperty( 'county-select-lines', 'line-color', ['match', ['get', 'FIPS'], selectedCounties, 'black', 'transparent'] );
          getCountyData( fips )
        }

      })

      // ------------------------------------------
      map.on( 'mouseleave', 'counties', () => {
        
        countyNameBox.remove()

        map.setFeatureState(
          { source: 'counties', id: hoveredCountyID, sourceLayer: 'original' },
          { hover: false }
        )

      })

    })
    .catch( error => {
      console.error( 'Could not retrieve data from LifeSource API' );
      console.log( error );
    })
    
})

setZoomLevel();